import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FaGithub } from 'react-icons/fa';
import { BsLinkedin } from 'react-icons/bs';
import { urlFor } from './../utils/sanity/urlFor';


function Footer({ logo }) {

  const footerLogo = logo[0].portfolioFooterLogo

  return (
    <footer className="w-full py-6 pb-6 px-6 xl:px-40 md:px-10 dark-background-color text-white main-font flex flex-col md:flex-row items-center">
      <Link to="/" className="ml-3 md:ml-0 hover:opacity-60 w-auto">
        <img src={urlFor(footerLogo)} alt="Portfolio logo" className="w-9 md:w-14" />
      </Link>
      <nav className="mt-4 md:mt-0 md:ml-4 md:py-1 md:pl-4 flex flex-row text-xs w-full justify-center md:justify-start">
        <NavLink to="/" className="mx-5 md:mx-10 hover:text-gray-400">
          HOME
        </NavLink>
        <NavLink to="/portfolio" className="mx-5 hover:text-gray-400">
          PORTFOLIO
        </NavLink>
        <NavLink to="/contactMe" className="mx-5 hover:text-gray-400">
          CONTACT ME
        </NavLink>
      </nav>
      <div className="flex flex-row mt-4 md:mt-0 w-auto">
        <a href="https://github.com/VILLAMORGO" rel="noreferrer" target="_blank">
          <FaGithub className="mx-4 text-3xl hover:opacity-60" />
        </a>
        <a href="https://www.linkedin.com/in/villamor-go/" rel="noreferrer" target="_blank">
          <BsLinkedin className="mx-4 text-3xl hover:opacity-60" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
